import { truktApi } from '@api';
import { v1 as uuid } from 'uuid';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getErrorMessage } from '@trukt/portal-utils/getErrorMessage';
import { useProgressNotifierContext } from '@trukt/ui/ProgressNotifierContext';
import { QUERY_CACHE_IDS_MAP } from '@types';

import { UseCreateReportMutationResult } from './useCreateReportMutation.types';

export const useCreateReportMutation = () => {
  const progressNotifierContext = useProgressNotifierContext();

  const queryClient = useQueryClient();

  const mutation: UseCreateReportMutationResult = useMutation({
    mutationFn: (request) => truktApi.report.create(request),

    onMutate: () => {
      const progressNotifierId = uuid();
      progressNotifierContext.dispatchNotification({
        id: progressNotifierId,
        label: 'Creating report.',
      });

      return { progressNotifierId };
    },

    onError: (error, _, context) => {
      if (context?.progressNotifierId) {
        progressNotifierContext.updateNotification(context.progressNotifierId, {
          errorMessage: getErrorMessage(error),
          isError: true,
        });
      }
    },

    onSuccess: (_, __, context) => {
      if (context?.progressNotifierId) {
        progressNotifierContext.updateNotification(context.progressNotifierId, {
          isSuccess: true,
        });

        queryClient.invalidateQueries({
          queryKey: [QUERY_CACHE_IDS_MAP.REPORTS],
        });
      }
    },
  });

  return mutation;
};
